module.exports = __webpack_public_path__ + "static/media/reportblueicon.e24f24b7.svg";